module.exports = __webpack_public_path__ + "static/media/ringbacktone.e21950b.wav";


//////////////////
// WEBPACK FOOTER
// ./static/audio/ringbacktone.wav
// module id = 75d2
// module chunks = 24